import {
    Component, DestroyRef, inject, ViewChild,
} from '@angular/core';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { FormControl, ReactiveFormsModule } from '@angular/forms';
import { firstValueFrom } from 'rxjs';
import { BreakpointService } from 'src/app/services/breakpoint.service';
import { ApolloService } from 'src/gql-generated/generated';
import { TableComponent, TableSettings } from '../../shared/table/table.component';
import { NgClass, NgIf, DatePipe } from '@angular/common';
import { MatFormField } from '@angular/material/form-field';
import { MatInput } from '@angular/material/input';
import { MatButton } from '@angular/material/button';
import { RouterLink } from '@angular/router';
import { MatColumnDef, MatHeaderCellDef, MatHeaderCell, MatCellDef, MatCell } from '@angular/material/table';
import { MatTooltip } from '@angular/material/tooltip';
import { MatIcon } from '@angular/material/icon';

@Component({
    selector: 'app-ai-models',
    templateUrl: './ai-models.component.html',
    styleUrl: './ai-models.component.scss',
    imports: [
        NgClass,
        MatFormField,
        MatInput,
        ReactiveFormsModule,
        MatButton,
        RouterLink,
        NgIf,
        TableComponent,
        MatColumnDef,
        MatHeaderCellDef,
        MatHeaderCell,
        MatCellDef,
        MatCell,
        MatTooltip,
        MatIcon,
        DatePipe,
    ],
})
export class AiModelsComponent {
    /**
     * Reference to models table
     */
    @ViewChild('table') table?: TableComponent;

    /**
     * Custom search control
     */
    searchControl = new FormControl('');

    /**
     * Settings for models table
     */
    modelsTableSettings: TableSettings = {
        getItems: (paginator, search) => firstValueFrom(this.apollo.getAiModels({
            limit: paginator.pageSize,
            offset: paginator.pageSize * paginator.pageIndex,
            where: {
                deleted_at: { _is_null: true },
                _or: [
                    { model: { _ilike: `%${search}%` } },
                    { provider: { _ilike: `%${search}%` } },
                    { type: { _ilike: `%${search}%` } },
                    { type_label: { _ilike: `%${search}%` } },
                ],
            },
        })),
        routerLinkFunction: (item) => `/settings/models/${item.id}`,
        hideSearch: true,
        hidePageSize: true,
    };

    /**
     * Destroy ref used in takeUntilDestroyed
     */
    private destroyRef = inject(DestroyRef);

    constructor(private apollo: ApolloService, public breakpoint: BreakpointService) { }

    /**
     * Logic after view is initialzied
     */
    ngAfterViewInit(): void {
        // Pass local searchControl values to table searchControl
        if (this.table) {
            this.searchControl.valueChanges.pipe(takeUntilDestroyed(this.destroyRef)).subscribe((s) => this.table?.searchControl.setValue(s));
        }
    }
}
